/** Globale Variablen **/

'use strict';

import jQuery from 'jquery';

jQuery(function($) {
    $(document).ready(function() {
        /**
		 * Modules
		 */
        // Moudles START
        $('[data-toggle]').on('click', function(e) {
            let strTarget = $(this).attr('href').split('#')[1];
            let strToggleClass = $(this).attr('data-toggle');
            let $target = $('#' + strTarget);

            if ($target && strToggleClass) {
                $target.toggleClass(strToggleClass);
            } else {
                console.log('no target specified or missing class');
            }

            e.preventDefault();
        });

        $('[data-toggle-self]').on('click', function(e) {
            var strToggleClass = $(this).attr('data-toggle-self');

            var $target = $(this);

            if ($target && strToggleClass) {
                $target.toggleClass(strToggleClass);
            } else {
                console.log('no target specified or missing class');
            }

            e.preventDefault();
        });

        $('[data-bem-toggle]').on('click', function(e) {
            var strBemToggleValue = $(this).attr('data-bem-toggle');
            var arrBemToggleValueSplit = strBemToggleValue.split('--');
            var strBemModifier = arrBemToggleValueSplit[arrBemToggleValueSplit.length - 1];
            var strClosestClass = '.' + strBemToggleValue.replace('--' + strBemModifier, '');
            var $target = $(this).closest(strClosestClass);
            var strToggleClass = $(this).attr('data-bem-toggle');

            if ($target && strToggleClass) {
                $('.' + strToggleClass).not($target).removeClass(strToggleClass);
                $target.toggleClass(strToggleClass);
            } else if ($(this).find(strClosestClass)) {
                $target = $(this).find(strClosestClass);
                $target.toggleClass(strToggleClass);
            } else {
                console.log('no target specified or missing class');
            }

            e.preventDefault();
        });

        $('[data-bem-toggle-remove]').on('click', function(e) {
            e.preventDefault();
            let strBemToggleValue = $(this).attr('data-bem-toggle-remove');
            let arrBemToggleValueSplit = strBemToggleValue.split('--');
            let strBemModifier = arrBemToggleValueSplit[arrBemToggleValueSplit.length - 1];
            let strClosestClass = '.' + strBemToggleValue.replace('--' + strBemModifier, '');
            let $target = $(this).closest(strClosestClass);
            let strToggleClass = $(this).attr('data-bem-toggle-remove');

            if ($target && strToggleClass) {
                $('.' + strToggleClass).not($target).removeClass(strToggleClass);
                $target.toggleClass(strToggleClass).siblings().removeClass(strToggleClass);
            } else if ($(this).find(strClosestClass)) {
                $target = $(this).find(strClosestClass);
                $target.toggleClass(strToggleClass);
            } else {
                console.log('no target specified or missing class');
            }
        });
        // Modules END
    });
});
